export default __webpack_public_path__ + "static/media/seiseki6.575e7364.png";